export const NAVIGATION_TOGGLE = '@Navigation_Toggle';
export const NAVIGATION_UPDATEVIEW = '@Navigation_UpdateView';



// WEBPACK FOOTER //
// ./src/app/stores/reducers/navigation/ActionsNavigation.ts